import { Inject, Injectable, Optional } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CORE_LAYOUT_SIDENAV_OPENED } from '../tokens';

@Injectable({ providedIn: 'root' })
export class CoreSidenavAdminService {
  private _isOpened = new BehaviorSubject<boolean>(false);
  open$ = this._isOpened.asObservable();

  constructor(@Optional() @Inject(CORE_LAYOUT_SIDENAV_OPENED) private uxOpenSidenavInitialState: boolean) {
    const initial =
      uxOpenSidenavInitialState !== undefined && uxOpenSidenavInitialState !== null
        ? !!uxOpenSidenavInitialState
        : sessionStorage.getItem('isArkikSidenavOpened') === 'true';
    this.setOpen(initial);
  }

  setOpen(open: boolean): void {
    sessionStorage.setItem('isArkikSidenavOpened', open ? 'true' : 'false');
    this._isOpened.next(open);
  }

  toggleCollapsed(): void {
    this.setOpen(!this._isOpened.value);
  }
}
